var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"מה הצעדים הראשונים כדי להבטיח את השקט שלנו בעזרת כרית ביטחון","button-text":"לקריאת המאמר","description":"7 דקות, מאמר","action-key":_vm.actionKey},on:{"click":_vm.openBlogPost}})}
var staticRenderFns = []

export { render, staticRenderFns }